import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import BankAccountListing from "pages/BankAccount/BankAccountListing";
import Error404 from "pages/404/Index";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import NewPurchase from "pages/Inventory/NewPurchase";
import PurchaseOrderListing from "pages/Inventory/PurchaseOrderListing";
import InventorySteps from "pages/Inventory/InventorySteps";
import PurchaseInvoiceListing from "pages/Inventory/PurchaseInvoiceListing";
import PurchaseInvoiceCreateUpdate from "pages/Inventory/PurchaseInvoiceCreateUpdate";
import StockReceivedListing from "pages/Inventory/StockReceivedListing";
import CreditNoteListing from "pages/Inventory/CreditNoteListing";
import StockReceivedCreateUpdate from "pages/Inventory/StockReceivedCreateUpdate";
import CreditNoteCreateUpdate from "pages/Inventory/CreditNoteCreateUpdate";
import UnstockListing from "pages/Inventory/UnstockListing";
import UnstockCreateUpdate from "pages/Inventory/UnstockCreateUpdate";
import BankAccountModal from "pages/BankAccount/BankAccountModal";
import BankDepositListing from "pages/BankDeposit/BankDepositListing";
import BankDepositModal from "pages/BankDeposit/BankDepositModal";
import JobCardListing from "pages/JobCard/JobCardListing";
import JobCardModal from "pages/JobCard/JobCardModal";
import WorkOrderListing from "pages/WorkOrder/WorkOrderListing";
import WorkOrderModal from "pages/WorkOrder/WorkOrderModal";
import InvoiceListing from "pages/Invoice/InvoiceListing";
import InvoiceModal from "pages/Invoice/InvoiceModal";
import PaymentModeListing from "pages/PaymentMode/PaymentModeListing";
import PaymentModeModal from "pages/PaymentMode/PaymentModeModal";
import ExpenseTypeListing from "pages/ExpenseType/ExpenseTypeListing";
import ExpenseTypeModal from "pages/ExpenseType/ExpenseTypeModal";
import PaymentModal from "pages/Payment/PaymentModal";
import PaymentListing from "pages/Payment/PaymentListing";
import VehicleListing from "pages/Vehicle/VehicleListing";
import VehicleModal from "pages/Vehicle/VehicleModal";
import CheckListItemListing from "pages/ChecklistItem/CheckListItemListing";
import ChecklistItemModal from "pages/ChecklistItem/CheckListItemModal";
import ChecklistListing from "pages/Checklist/ChecklistListing";
import ChecklistModal from "pages/Checklist/ChecklistModal";
import StockTransferListing from "pages/Inventory/StockTransferListing";
import StockTransferCreateUpdate from "pages/Inventory/StockTransferCreateUpdate";
import StockAdjustmentListing from "pages/Inventory/StockAdjustmentListing";
import StockAdjustmentCreateUpdate from "pages/Inventory/StockAdjustmentCreateUpdate";
import MakeListing from "pages/Make/MakeListing";
import MakeModal from "pages/Make/MakeModal";
import ModelListing from "pages/Model/ModelListing";
import ModelModal from "pages/Model/ModelModal";
import ModelEngineListing from "pages/ModelEngine/ModelEngineListing";
import ModelServiceTable from "pages/Model/ModelServiceTable";
import ModelEngineModal from "pages/ModelEngine/ModelEngineModal";
import VehicleTypeListing from "pages/VehicleType/VehicleTypeListing";
import VehicleTypeModal from "pages/VehicleType/VehicleTypeModal";
import VehicleStatusListing from "pages/VehicleStatus/VehicleStatusListing";
import VehicleStatusModal from "pages/VehicleStatus/VehicleStatusModal";
import UsersListing from "pages/Users/UsersListing";
import UsersModal from "pages/Users/UsersModal";
import UpdatePassword from "pages/Users/UpdatePassword";
import ActivityLogsListing from "pages/ActivityLogs/ActivityLogsListing";
import Reports from "pages/Reports";
import BusinessListing from "pages/Business/BusinessListing";
import BusinessModal from "pages/Business/BusinessModal";
import RolesListing from "pages/Roles/RolesListing";
import RolesModal from "pages/Roles/RolesModal";
import RolePrivileges from "pages/Roles/RolePrivileges";
import ManufacturersListing from "pages/Manufacturer/ManufacturersListing";
import ManufacturersModal from "pages/Manufacturer/ManufacturersModal";
import BusinessGroupsListing from "pages/BusinessGroup/BusinessGroupListing";
import BusinessGroupsModal from "pages/BusinessGroup/BusinessGroupModal";
import BusinessGroupStationTable from "pages/BusinessGroup/BusinessGroupStationTable";
import ClientsListing from "pages/Client/ClientsListing";
import ClientsModal from "pages/Client/ClientsModal";
import UpdatePasswordClient from "pages/Client/UpdatePassword";
import CustomersModal from "pages/Customer/CustomersModal";
import UpdatePasswordCustomer from "pages/Customer/UpdatePassword";
import CustomersListing from "pages/Customer/CustomersListing";
import ClientGroupsListing from "pages/ClientGroup/ClientGroupListing";
import ClientGroupsModal from "pages/ClientGroup/ClientGroupModal";
import ClientGroupClientTable from "pages/ClientGroup/ClientGroupCientTable";
import UserGroupsListing from "pages/UserGroup/UserGroupListing";
import UserGroupsModal from "pages/UserGroup/UserGroupModal";
import UserGroupUserTable from "pages/UserGroup/UserGroupUserTable";
import StationGroupsListing from "pages/StationGroup/StationGroupListing";
import StationGroupsModal from "pages/StationGroup/StationGroupModal";
import StationGroupStationTable from "pages/StationGroup/StationGroupStationTable";
import BaysListing from "pages/Bay/BaysListing";
import BaysModal from "pages/Bay/BaysModal";
import StoreListing from "pages/Store/StoreListing";
import StoreModal from "pages/Store/StoreModal";
import StoreRacksListing from "pages/Store/Racks/StoreRacksListing";
import RackModal from "pages/Store/Racks/RackModal";
import StateListing from "pages/State/StateListing";
import StateModal from "pages/State/StateModal";
import StationListing from "pages/Station/StationListing";
import StationModal from "pages/Station/StationModal";
import StationStoreTable from "pages/Station/StationStoreTable";
import StationBankAccountTable from "pages/Station/StationBankAccountTable";
import StationUserTable from "pages/Station/StationUserTable";
// import StationBayTable from "pages/Station/StationBayTable";
// import StationWarehouseTable from "pages/Station/StationWarehouseTable";
import InspectionFormListing from "pages/InspectionForm/InspectionFormListing";
import InspectionFormModalNew from "pages/InspectionForm/InspectionFormModalNew";
import InspectionSectionListing from "pages/InspectionForm/InspectionSectionListing";
import InspectionSectionModal from "pages/InspectionForm/InspectionSectionModal";
import InspectionFormItemListing from "pages/InspectionForm/InspectionFormItemListing";
import InspectionFormItemModal from "pages/InspectionForm/InspectionFormItemModal";
import ChangePassword from "pages/AccountSettings/ChangePassword";
import NotificationSettings from "pages/AccountSettings/NotificationSettings";
import BusinessSettings from "pages/AccountSettings/BusinessSettings";
import SubscriptionPlanUsage from "pages/AccountSettings/SubscriptionPlanUsage";
import InvoiceTemplatesListing from "pages/AccountSettings/InvoiceTemplatesListing";
import LoginPage from "pages/Login/Login";
import ItemGroupListing from "pages/ItemGroup/ItemGroupListing";
import ItemGroupModal from "pages/ItemGroup/ItemGroupModal";
import ItemGroupItemTable from "pages/ItemGroup/ItemGroupItemTable";
import ItemsListing from "pages/Items/ItemsListing";
import ItemsModal from "pages/Items/ItemsModal";
import ItemModelTable from "pages/Items/ItemsModelTable";
import ItemsHistoryTable from "pages/Items/ItemsHistoryTable";
import ItemSupplierTable from "pages/Items/ItemSupplierTable";
import ItemsUnitListing from "pages/Items/ItemsUnit/Index";
import ItemsPriceListListing from "pages/Items/ItemsPriceList/Index";
import ItemsStoreListing from "pages/Items/ItemsStore/Index";
import ServiceGroupListing from "pages/ServiceGroup/ServiceGroupListing";
import ServiceGroupModal from "pages/ServiceGroup/ServiceGroupModal";
import ServiceGroupServiceTable from "pages/ServiceGroup/ServiceGroupServiceTable";
import ServicesListing from "pages/Service/ServicesListing";
import ServicesModal from "pages/Service/ServicesModal";
import ServiceItemsTable from "pages/Service/ServiceItemsTable";
import ServiceVehicleTypesTable from "pages/Service/ServiceVehicleTypes";
import ServiceStationsTable from "pages/Service/ServiceStationsTable";
import ServiceModelsTable from "pages/Service/ServiceModelsTable";
import ServicesPricelistListing from "pages/Service/ServicePricelists/Index";
import PackageGroupListing from "pages/PackageGroup/PackageGroupListing";
import PackageGroupModal from "pages/PackageGroup/PackageGroupModal";
import PackageGroupPackageTable from "pages/PackageGroup/PackageGroupPackageTable";
import PackagesListing from "pages/Packages/PackagesListing";
import PackagesModal from "pages/Packages/PackagesModal";
import PackageServicesTable from "pages/Packages/PackageServicesTable";
import PackageItemsTable from "pages/Packages/PackageItemsTable";
import PackageStationsTable from "pages/Packages/PackageStationsTable";
import PackageModelsTable from "pages/Packages/PackageModelsTable";
import PackagePricelistsListing from "pages/Packages/PackagePricelists/Index";
import ItemCategoriesListing from "pages/ItemCatagories/ItemCategoriesListing";
import ItemCategoryModal from "pages/ItemCatagories/ItemCategoryModal";
import UnitModal from "pages/Units/UnitModal";
import UnitsListing from "pages/Units/UnitsListing";
import Marketplace from "pages/Marketplace/Marketplace";
import TaxProcedureListing from "pages/TaxProcedure/TaxProcedureListing";
import TaxProcedureModal from "pages/TaxProcedure/TaxProcedureModal";
import SupplierListing from "pages/Supplier/SupplierListing";
import SupplierModal from "pages/Supplier/SupplierModal";
import WarehouseListing from "pages/Warehouse/WarehouseListing";
import WarehouseModal from "pages/Warehouse/WarehouseModal";
import StatusesListing from "pages/Statuses/StatusesListing";
import StatusesModal from "pages/Statuses/StatusesModal";
import PricelistListing from "pages/PriceList/PricelistListing";
import PricelistsModal from "pages/PriceList/PricelistModal";
import PricelistItemsListing from "pages/PriceList/PricelistItems/Index";
import PricelistServicesListing from "pages/PriceList/PricelistServices/Index";
import PricelistPackagesListing from "pages/PriceList/PricelistPackages/Index";
import { useSelector } from "react-redux";
import { selectUserInfo } from "features/user/userSlice";
import StationTermsAndConditions from "pages/Station/StationTermsAndConditions";
import StationPlanUsage from "pages/Station/StationPlanUsage";
import PrintStockReceived from "pages/Inventory/PrintScreens/PrintStockReceived";
import PrintPurchaseInvoice from "pages/Inventory/PrintScreens/PrintPurchaseInvoice";
import PrintCreditNote from "pages/Inventory/PrintScreens/PrintCreditNote";
import PrintUnstock from "pages/Inventory/PrintScreens/PrintUnstock";
import PrintStockTransfer from "pages/Inventory/PrintScreens/PrintStockTransfer";
import PrintStockAdjustment from "pages/Inventory/PrintScreens/PrintStockAdjustment";
import PrintPurchaseOrder from "pages/Inventory/PrintScreens/PurchaseOrder/PrintPurchaseOrder";
import PrintPurchaseOrderInvoice from "pages/Inventory/PrintScreens/PurchaseOrder/PrintPurchaseOrderInvoice";
import PrintPurchaseOrderStockReceived from "pages/Inventory/PrintScreens/PurchaseOrder/PrintPurchaseOrderStockReceived";
import PrintPurchaseOrderCreditNote from "pages/Inventory/PrintScreens/PurchaseOrder/PrintPurchaseOrderCreditNote";
import PrintPurchaseOrderUnstock from "pages/Inventory/PrintScreens/PurchaseOrder/PrintPurchaseOrderUnstock";
import StoreItemsListing from "pages/Store/StoreItems/Index";
import ExpensesListing from "pages/Expenses/ExpensesListing";
import ExpensesModal from "pages/Expenses/ExpensesModal";
import DriversListing from "pages/Driver/DriversListing";
import DriversModal from "pages/Driver/DriversModal";
import PurchasePaymentListing from "pages/Inventory/PurchasePaymentListing";
import PurchasePaymentCreateUpdate from "pages/Inventory/PurchasePaymentCreateUpdate";
import PrintPurchasePayment from "pages/Inventory/PrintScreens/PrintPurchasePayment";
import ServiceGroupTechnicianTable from "pages/ServiceGroup/ServiceGroupTechnicianTable";
import ClientVehicles from "pages/Client/ClientVehicles";
import ClientInvoices from "pages/Client/ClientInvoices";
import ClientPayments from "pages/Client/ClientPayments";
import SalesCreditNotesListing from "pages/SalesCreditNotes/SalesCreditNoteListing";
import SalesCreditNotesModal from "pages/SalesCreditNotes/SalesCreditNotesModal";
import ViewPayment from "pages/Payment/ViewPayment";
import Analytics from "pages/Analytics";
import CancellationReasonListing from "pages/CancellationReasons/CancellationReasonsListing";
import CancellationReasonModal from "pages/CancellationReasons/CancellationReasonsModal";
import EstimationListing from "pages/Estimation/EstimationListing";
import EstimationModal from "pages/Estimation/EstimationModal";
import CustomerVehicles from "pages/Customer/CustomerVehicles";
import CustomerInvoices from "pages/Customer/CustomerInvoices";
import CustomerPayments from "pages/Customer/CustomerPayments";
import StockLevelListing from "pages/Inventory/StockLevelListing";
import KpiDashboard from "pages/KPIs";
import InsuranceCompaniesListing from "pages/Insurance/InsuranceCompaniesListing";
import InvoiceTemplatesModal from "pages/AccountSettings/InvoiceTemplatesModal";
import AccountsSummary from "pages/AccountsSummary";
import InsuranceCompaniesModal from "pages/Insurance/InsuranceCompaniesModal";
import InsurancePoliciesListing from "pages/Insurance/InsurancePoliciesListing";
import InsurancePoliciesModal from "pages/Insurance/InsurancePoliciesModal";
import DeliveryNotesListing from "pages/DeliveryNotes/DeliveryNotesListing";
import DeliveryNoteModal from "pages/DeliveryNotes/DeliveryNoteModal";
import DeliveryNoteDownloadPreview from "pages/DeliveryNotes/DeliveryNoteDownloadPreview";
import ClientDeliveryNotes from "pages/Client/ClientDeliveryNotes";
import ViewExpense from "pages/Expenses/ViewExpense";
import IntegrationsListing from "pages/Business/Integrations/IntegrationListing";
import IntegrationModal from "pages/Business/Integrations/IntegrationModal";
import InvoiceDownloadPreview from "pages/Invoice/InvoiceDownloadPreview";
import SupplierPayments from "pages/Supplier/SupplierPayments";
import SupplierPurchaseOrders from "pages/Supplier/SupplierPurchaseOrders";
import SupplierBills from "pages/Supplier/SupplierBills";
import SupplierStockReceives from "pages/Supplier/SupplierStockReceives";
import SupplierDebitNotes from "pages/Supplier/SupplierDebitNotes";
import AccountLedgerListing from "pages/BankAccount/AccountLedgerListing";
import InterAccountTransferListing from "pages/InterAccountTransfer/InterAccountTransferListing";
import InterAccountTransferCreate from "pages/InterAccountTransfer/InterAccountTransferCreate";
import HostingDetailsListing from "pages/HostingDetails/HostingDetailsListing";
import HostingDetailsModal from "pages/HostingDetails/HostingDetailsModal";
import VehicleInvoices from "pages/Vehicle/VehicleInvoices";
import VehicleBookings from "pages/Vehicle/VehicleBookings";
import VehicleJobCards from "pages/Vehicle/VehicleJobCards";
import VehicleWorkOrders from "pages/Vehicle/VehicleWorkOrders";
import VehicleInspections from "pages/Vehicle/VehicleInspections";
import VehiclePayments from "pages/Vehicle/VehiclePayments";
import VehicleServiceRecommendations from "pages/Vehicle/VehicleServiceRecommendations";
import VehicleServiceHistory from "pages/Vehicle/VehicleServiceHistory";
import CustomerReviews from "pages/Customer/CustomerReviews";
import ClientReviews from "pages/Client/ClientReviews";
import ClientIntegrationsListing from "pages/Client/ClientIntegrationsListing";
import ClientIntegrationModal from "pages/Client/ClientIntegrationModal";
import InspectionListing from "pages/Inspections/InspectionsListing";
import ViewSalesCreditNote from "pages/SalesCreditNotes/ViewSalesCreditNote";
import BusinessStations from "pages/Business/BusinessStations";
import InventoryAnalytics from "pages/InventoryAnalytics";
import CustomerAnalyticsDashboard from "pages/CustomerAnalytics";
import IntegrationLogsListing from "pages/ActivityLogs/IntegrationLogsListing";
import ViewInspection from "pages/Inspections/ViewInspection";
import InspectionDownloadPreview from "pages/Inspections/InspectionDownloadPreview";
import SubscriptionPlansListing from "pages/SubscriptionPlans/SubscriptionPlansListing";
import SubscriptionPlansModal from "pages/SubscriptionPlans/SubscriptionPlansModal";
import SubscriptionAnalytics from "pages/Business/SubscriptionAnalytics";
import {
  checkSubscriptions,
  checkSubscriptionFeatureItem,
} from "Helpers/CheckSubscriptions";
import {
  subscriptionStatusesInfo,
  selectSubscriptionPlanMeta,
} from "features/subscription/subscriptionSlice";

/** Avoid redirecting to /login before layout runs LoginAs (Navigate's effect runs before layout's). */
function RootEntry() {
  const [searchParams] = useSearchParams();
  if (searchParams.get("loginAsUser")) return null;
  return <Navigate to="/login" replace />;
}

const AppRoutes = () => {
  const loggedInUserData = useSelector(selectUserInfo);
  // Re-render routes when plan features / hasPlan change (gates use checkSubscriptions).
  useSelector(subscriptionStatusesInfo);
  useSelector(selectSubscriptionPlanMeta);
  return (
    <Routes>
      <Route path="/" element={<RootEntry />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/users"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_USER_VIEW") && <UsersListing />
        }
      />
      <Route
        path="/user/create"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_USER_CREATE") && <UsersModal />
        }
      />
      <Route
        path="/user/:id"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_USER_UPDATE") && <UsersModal />
        }
      />
      <Route
        path="/user/update-password/:id"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_CHANGE_PASSWORD") && <UpdatePassword />
        }
      />
      <Route
        path="/businesses"
        element={
          checkPrivileges("ROLE_BUSINESS_VIEW") &&
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) ? (
            <BusinessListing />
          ) : null
        }
      />
      <Route
        path="/business/create"
        element={
          checkPrivileges("ROLE_BUSINESS_CREATE") &&
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) ? (
            <BusinessModal />
          ) : null
        }
      />
      <Route
        path="/business/:id"
        element={
          checkPrivileges("ROLE_BUSINESS_UPDATE") &&
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) ? (
            <BusinessModal />
          ) : null
        }
      />
      <Route
        path="/roles"
        element={checkPrivileges("ROLE_ROLE_VIEW") && <RolesListing />}
      />
      <Route
        path="/role/create"
        element={checkPrivileges("ROLE_ROLE_CREATE") && <RolesModal />}
      />
      <Route
        path="/role/:id"
        element={checkPrivileges("ROLE_ROLE_UPDATE") && <RolesModal />}
      />
      <Route
        path="/role/assign/privilege/:id"
        element={
          checkPrivileges("ROLE_ROLE_PRIVILEGE_ASSIGN") ||
          checkPrivileges("ROLE_ROLE_PRIVILEGE_UNASSIGN") ? (
            <RolePrivileges />
          ) : null
        }
      />
      <Route
        path="/user-groups"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_USERGROUP_VIEW") && <UserGroupsListing />
        }
      />
      <Route
        path="/user-group/create"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_USERGROUP_CREATE") && <UserGroupsModal />
        }
      />
      <Route
        path="/user-group/:id"
        element={
          checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_USERGROUP_UPDATE") && <UserGroupsModal />
        }
      />
      <Route
        path="/user-group/assign/user/:id"
        element={
          checkSubscriptions("USERS") &&
          (checkPrivileges("ROLE_USERGROUP_USER_ASSIGN") ||
            checkPrivileges("ROLE_USERGROUP_USER_UNASSIGN")) ? (
            <UserGroupUserTable />
          ) : null
        }
      />
      <Route
        path="/clients"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENT_VIEW") && <ClientsListing />
        }
      />
      <Route
        path="/client/create"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENT_CREATE") && <ClientsModal />
        }
      />
      <Route
        path="/client/:id/account/:accountId/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENT_UPDATE") && <ClientsModal />
        }
      />
      <Route
        path="/client/:id/account/:accountId/update-password/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CHANGE_PASSWORD") && <UpdatePasswordClient />
        }
      />
      <Route
        path="/customers"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkPrivileges("ROLE_CUSTOMER_VIEW") && <CustomersListing />
        }
      />
      <Route
        path="/customer/create"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkPrivileges("ROLE_CUSTOMER_CREATE") && <CustomersModal />
        }
      />
      <Route
        path="/customer/:id"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkPrivileges("ROLE_CUSTOMER_UPDATE") && <CustomersModal />
        }
      />
      <Route
        path="/customer/:id/update-password"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkPrivileges("ROLE_CHANGE_PASSWORD") && <UpdatePasswordCustomer />
        }
      />
      <Route
        path="/makes"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_MAKE_VIEW") && <MakeListing />
        }
      />
      <Route
        path="/make/create"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_MAKE_CREATE") && <MakeModal />
        }
      />
      <Route
        path="/make/:id"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_MAKE_UPDATE") && <MakeModal />
        }
      />
      <Route
        path="/models"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_MODEL_VIEW") && <ModelListing />
        }
      />
      <Route
        path="/model/create"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_MODEL_CREATE") && <ModelModal />
        }
      />
      <Route
        path="/model/:id"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_MODEL_UPDATE") && <ModelModal />
        }
      />
      <Route
        path="/model/assign/service/:id"
        element={
          checkSubscriptions("VEHICLES") &&
          (checkPrivileges("ROLE_MODEL_SERVICE_ASSIGN") ||
            checkPrivileges("ROLE_MODEL_SERVICE_UNASSIGN")) ? (
            <ModelServiceTable />
          ) : null
        }
      />
      <Route
        path="/model-engines"
        element={
          checkPrivileges("ROLE_MODELENGINE_VIEW") && <ModelEngineListing />
        }
      />
      <Route
        path="/model-engine/create"
        element={
          checkPrivileges("ROLE_MODELENGINE_CREATE") && <ModelEngineModal />
        }
      />
      <Route
        path="/model-engine/:id"
        element={
          checkPrivileges("ROLE_MODELENGINE_UPDATE") && <ModelEngineModal />
        }
      />
      <Route
        path="/vehicle-types"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLETYPE_VIEW") && <VehicleTypeListing />
        }
      />
      <Route
        path="/vehicle-type/create"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLETYPE_CREATE") && <VehicleTypeModal />
        }
      />
      <Route
        path="/vehicle-type/:id"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLETYPE_UPDATE") && <VehicleTypeModal />
        }
      />
      <Route
        path="/vehicles"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLE_VIEW") && <VehicleListing />
        }
      />
      <Route
        path="/vehicle/create"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLE_CREATE") && <VehicleModal />
        }
      />
      <Route
        path="/vehicle/:id"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLE_UPDATE") && <VehicleModal />
        }
      />
      <Route
        path="/stations"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_VIEW") && <StationListing />
        }
      />
      <Route
        path="/station/create"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_CREATE") && <StationModal />
        }
      />
      <Route
        path="/station/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_UPDATE") && <StationModal />
        }
      />
      <Route
        path="/station/assign/store/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_STORE_ASSIGN") ||
          checkPrivileges("ROLE_STATION_STORE_UNASSIGN") ? (
            <StationStoreTable />
          ) : null
        }
      />
      <Route
        path="/station/assign/account/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_BANKACCOUNT_ASSIGN") ||
          checkPrivileges("ROLE_STATION_BANKACCOUNT_UNASSIGN") ? (
            <StationBankAccountTable />
          ) : null
        }
      />
      <Route
        path="/station/assign/user/:id"
        element={
          // checkSubscriptions("USERS") &&
          checkPrivileges("ROLE_STATION_USER_ASSIGN") ||
          checkPrivileges("ROLE_STATION_USER_ASSIGN") ? (
            <StationUserTable />
          ) : null
        }
      />
      {/* <Route
        path="/station/assign/bay/:id"
        element={
          checkSubscriptions("STATIONS") && (checkPrivileges("ROLE_STATION_BAY_ASSIGN") ||
          checkPrivileges("ROLE_STATION_BAY_UNASSIGN") )? (
            <StationBayTable />
          ) : null
        }
      /> */}
      {/* <Route
        path="/station/assign/warehouse/:id"
        element={
          checkSubscriptions("STATIONS") && (checkPrivileges("ROLE_STATION_WAREHOUSE_ASSIGN") ||
          checkPrivileges("ROLE_STATION_WAREHOUSE_UNASSIGN")) ? (
            <StationWarehouseTable />
          ) : null
        }
      /> */}
      <Route
        path="/station/:id/terms-and-conditions"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_TERMANDCONDITION_VIEW") && (
            <StationTermsAndConditions />
          )
        }
      />
      <Route
        path="/station/:id/plan-usage"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_UPDATE") && <StationPlanUsage />
        }
      />
      <Route
        path="/accounts"
        element={
          checkSubscriptions("ACCOUNT_MODULE") &&
          checkPrivileges("ROLE_BANKACCOUNT_VIEW") && <BankAccountListing />
        }
      />
      <Route
        path="/account/create"
        element={
          checkSubscriptions("ACCOUNT_MODULE") &&
          checkPrivileges("ROLE_BANKACCOUNT_CREATE") && <BankAccountModal />
        }
      />
      <Route
        path="/account/:id"
        element={
          checkSubscriptions("ACCOUNT_MODULE") &&
          checkPrivileges("ROLE_BANKACCOUNT_UPDATE") && <BankAccountModal />
        }
      />
      <Route
        path="/bank-deposits"
        element={
          checkPrivileges("ROLE_BANKDEPOSIT_VIEW") && <BankDepositListing />
        }
      />
      <Route
        path="/bank-deposit/create"
        element={
          checkPrivileges("ROLE_BANKDEPOSIT_CREATE") && <BankDepositModal />
        }
      />
      <Route
        path="/bank-deposit/:id"
        element={
          checkPrivileges("ROLE_BANKDEPOSIT_UPDATE") && <BankDepositModal />
        }
      />
      <Route
        path="/parts"
        element={checkPrivileges("ROLE_ITEM_VIEW") && <ItemsListing />}
      />
      <Route
        path="/part/create"
        element={checkPrivileges("ROLE_ITEM_CREATE") && <ItemsModal />}
      />
      <Route
        path="/part/:id"
        element={checkPrivileges("ROLE_ITEM_UPDATE") && <ItemsModal />}
      />
      <Route
        path="/part/assign/unit/:id"
        element={
          checkPrivileges("ROLE_ITEM_UNIT_ASSIGN") ||
          checkPrivileges("ROLE_ITEM_UNIT_UNASSIGN") ? (
            <ItemsUnitListing />
          ) : null
        }
      />
      <Route
        path="/part/assign/model/:id"
        element={
          checkPrivileges("ROLE_ITEM_MODEL_ASSIGN") ||
          checkPrivileges("ROLE_ITEM_MODEL_UNASSIGN") ? (
            <ItemModelTable />
          ) : null
        }
      />
      <Route
        path="/part/assign/supplier/:id"
        element={
          checkPrivileges("ROLE_ITEM_VENDOR_ASSIGN") ||
          checkPrivileges("ROLE_ITEM_VENDOR_UNASSIGN") ? (
            <ItemSupplierTable />
          ) : null
        }
      />
      <Route
        path="/part/assign/price-list/:id"
        element={
          checkPrivileges("ROLE_ITEM_PRICELIST_ASSIGN") ||
          checkPrivileges("ROLE_ITEM_PRICELIST_UNASSIGN") ? (
            <ItemsPriceListListing />
          ) : null
        }
      />
      <Route
        path="/part/history/:id"
        element={
          checkPrivileges("ROLE_ITEM_HISTORY_VIEW") && <ItemsHistoryTable />
        }
      />
      <Route
        path="/part/assign/store/:id"
        element={
          checkPrivileges("ROLE_STORE_ITEM_ASSIGN") ||
          checkPrivileges("ROLE_STORE_ITEM_UNASSIGN") ? (
            <ItemsStoreListing />
          ) : null
        }
      />
      <Route
        path="/packages"
        element={checkPrivileges("ROLE_PACKAGE_VIEW") && <PackagesListing />}
      />
      <Route
        path="/package/create"
        element={checkPrivileges("ROLE_PACKAGE_CREATE") && <PackagesModal />}
      />
      <Route
        path="/package/:id"
        element={checkPrivileges("ROLE_PACKAGE_UPDATE") && <PackagesModal />}
      />
      <Route
        path="/package/assign/service/:id"
        element={
          checkPrivileges("ROLE_PACKAGE_SERVICE_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGE_SERVICE_UNASSIGN") ? (
            <PackageServicesTable />
          ) : null
        }
      />
      <Route
        path="/package/assign/part/:id"
        element={
          checkPrivileges("ROLE_PACKAGE_ITEM_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGE_ITEM_UNASSIGN") ? (
            <PackageItemsTable />
          ) : null
        }
      />
      <Route
        path="/package/assign/station/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_PACKAGE_STATION_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGE_STATION_UNASSIGN") ? (
            <PackageStationsTable />
          ) : null
        }
      />
      <Route
        path="/package/assign/model/:id"
        element={
          checkPrivileges("ROLE_PACKAGE_MODEL_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGE_MODEL_UNASSIGN") ? (
            <PackageModelsTable />
          ) : null
        }
      />
      <Route
        path="/package/assign/price-list/:id"
        element={
          checkPrivileges("ROLE_PACKAGE_PRICELIST_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGE_PRICELIST_UNASSIGN") ? (
            <PackagePricelistsListing />
          ) : null
        }
      />
      <Route
        path="/part-categories"
        element={
          checkPrivileges("ROLE_ITEMCATEGORY_VIEW") && <ItemCategoriesListing />
        }
      />
      <Route
        path="/part-category/create"
        element={
          checkPrivileges("ROLE_ITEMCATEGORY_CREATE") && <ItemCategoryModal />
        }
      />
      <Route
        path="/part-category/:id"
        element={
          checkPrivileges("ROLE_ITEMCATEGORY_UPDATE") && <ItemCategoryModal />
        }
      />
      <Route
        path="/bays"
        element={
          checkSubscriptions("BAYS") &&
          checkPrivileges("ROLE_BAY_VIEW") && <BaysListing />
        }
      />
      <Route
        path="/bay/create"
        element={
          checkSubscriptions("BAYS") &&
          checkPrivileges("ROLE_BAY_CREATE") && <BaysModal />
        }
      />
      <Route
        path="/bay/:id"
        element={
          checkSubscriptions("BAYS") &&
          checkPrivileges("ROLE_BAY_UPDATE") && <BaysModal />
        }
      />
      <Route
        path="/client-groups"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENTGROUP_VIEW") && <ClientGroupsListing />
        }
      />
      <Route
        path="/client-group/create"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENTGROUP_CREATE") && <ClientGroupsModal />
        }
      />
      <Route
        path="/client-group/:id"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENTGROUP_UPDATE") && <ClientGroupsModal />
        }
      />
      <Route
        path="/client-group/assign/client/:id"
        element={
          checkSubscriptions("CLIENT") &&
          (checkPrivileges("ROLE_CLIENTGROUP_CLIENT_ASSIGN") ||
            checkPrivileges("ROLE_CLIENTGROUP_CLIENT_UNASSIGN")) ? (
            <ClientGroupClientTable />
          ) : null
        }
      />
      <Route
        path="/parts-group"
        element={checkPrivileges("ROLE_ITEMGROUP_VIEW") && <ItemGroupListing />}
      />
      <Route
        path="/part-group/create"
        element={checkPrivileges("ROLE_ITEMGROUP_CREATE") && <ItemGroupModal />}
      />
      <Route
        path="/part-group/:id"
        element={checkPrivileges("ROLE_ITEMGROUP_UPDATE") && <ItemGroupModal />}
      />
      <Route
        path="/part-group/assign/part/:id"
        element={
          checkPrivileges("ROLE_ITEMGROUP_ITEM_ASSIGN") ||
          checkPrivileges("ROLE_ITEMGROUP_ITEM_UNASSIGN") ? (
            <ItemGroupItemTable />
          ) : null
        }
      />
      <Route
        path="/services-group"
        element={
          checkPrivileges("ROLE_SERVICEGROUP_VIEW") && <ServiceGroupListing />
        }
      />
      <Route
        path="/service-group/create"
        element={
          checkPrivileges("ROLE_SERVICEGROUP_CREATE") && <ServiceGroupModal />
        }
      />
      <Route
        path="/service-group/:id"
        element={
          checkPrivileges("ROLE_SERVICEGROUP_UPDATE") && <ServiceGroupModal />
        }
      />
      <Route
        path="/service-group/assign/service/:id"
        element={
          checkPrivileges("ROLE_SERVICEGROUP_SERVICE_ASSIGN") ||
          checkPrivileges("ROLE_SERVICEGROUP_SERVICE_UNASSIGN") ? (
            <ServiceGroupServiceTable />
          ) : null
        }
      />
      <Route
        path="/service-group/assign/technician/:id"
        element={
          checkPrivileges("ROLE_SERVICEGROUP_TECHNICIAN_ASSIGN") ||
          checkPrivileges("ROLE_SERVICEGROUP_TECHNICIAN_UNASSIGN") ? (
            <ServiceGroupTechnicianTable />
          ) : null
        }
      />
      <Route
        path="/inspection-forms"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORM_VIEW") && (
            <InspectionFormListing />
          )
        }
      />
      <Route
        path="/inspection-form/create"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORM_CREATE") && (
            <InspectionFormModalNew />
          )
        }
      />
      <Route
        path="/inspection-form/:id"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORM_UPDATE") && (
            <InspectionFormModalNew />
          )
        }
      />
      <Route
        path="/inspection-sections/:id"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORM_SECTION_VIEW") && (
            <InspectionSectionListing />
          )
        }
      />
      <Route
        path="/inspection-section/:id/create"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORM_SECTION_CREATE") && (
            <InspectionSectionModal />
          )
        }
      />
      <Route
        path="/inspection-section/:id/edit/:isid"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORM_SECTION_UPDATE") && (
            <InspectionSectionModal />
          )
        }
      />
      <Route
        path="/inspection-form-items/:id"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORMITEM_VIEW") && (
            <InspectionFormItemListing />
          )
        }
      />
      <Route
        path="/inspection-form-item/:id/create"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORMITEM_CREATE") && (
            <InspectionFormItemModal />
          )
        }
      />
      <Route
        path="/inspection-form-item/:id/edit/:ifid"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_INSPECTIONFORMITEM_UPDATE") && (
            <InspectionFormItemModal />
          )
        }
      />
      <Route
        path="/price-lists"
        element={checkPrivileges("ROLE_PRICELIST_VIEW") && <PricelistListing />}
      />
      <Route
        path="/price-list/create"
        element={
          checkPrivileges("ROLE_PRICELIST_CREATE") && <PricelistsModal />
        }
      />
      <Route
        path="/price-list/:id"
        element={
          checkPrivileges("ROLE_PRICELIST_UPDATE") && <PricelistsModal />
        }
      />
      <Route
        path="/price-list/assign/package/:id"
        element={
          checkPrivileges("ROLE_PACKAGE_PRICELIST_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGE_PRICELIST_UNASSIGN") ? (
            <PricelistPackagesListing />
          ) : null
        }
      />
      <Route
        path="/price-list/assign/service/:id"
        element={
          checkPrivileges("ROLE_SERVICE_PRICELIST_ASSIGN") ||
          checkPrivileges("ROLE_SERVICE_PRICELIST_UNASSIGN") ? (
            <PricelistServicesListing />
          ) : null
        }
      />
      <Route
        path="/price-list/assign/part/:id"
        element={
          checkPrivileges("ROLE_ITEM_PRICELIST_ASSIGN") ||
          checkPrivileges("ROLE_ITEM_PRICELIST_UNASSIGN") ? (
            <PricelistItemsListing />
          ) : null
        }
      />
      <Route
        path="/stores"
        element={
          checkSubscriptions("STORES") &&
          checkPrivileges("ROLE_STORE_VIEW") && <StoreListing />
        }
      />
      <Route
        path="/store/create"
        element={
          checkSubscriptions("STORES") &&
          checkPrivileges("ROLE_STORE_CREATE") && <StoreModal />
        }
      />
      <Route
        path="/store/:id/racks"
        element={
          checkSubscriptions("STORES") &&
          checkPrivileges("ROLE_STORE_VIEW") && <StoreRacksListing />
        }
      />
      <Route
        path="/store/:id/rack/create"
        element={
          checkSubscriptions("STORES") &&
          checkPrivileges("ROLE_STORE_UPDATE") && <RackModal />
        }
      />
      <Route
        path="/store/:id/rack/:rackId"
        element={
          checkSubscriptions("STORES") &&
          checkPrivileges("ROLE_STORE_UPDATE") && <RackModal />
        }
      />
      <Route
        path="/store/:id"
        element={
          checkSubscriptions("STORES") &&
          checkPrivileges("ROLE_STORE_UPDATE") && <StoreModal />
        }
      />
      <Route
        path="/store/assign/part/:id"
        element={
          checkSubscriptions("STORES") &&
          (checkPrivileges("ROLE_STORE_ITEM_ASSIGN") ||
            checkPrivileges("ROLE_STORE_ITEM_UNASSIGN")) ? (
            <StoreItemsListing />
          ) : null
        }
      />
      <Route
        path="/services"
        element={checkPrivileges("ROLE_SERVICE_VIEW") && <ServicesListing />}
      />
      <Route
        path="/service/create"
        element={checkPrivileges("ROLE_SERVICE_CREATE") && <ServicesModal />}
      />
      <Route
        path="/service/:id"
        element={checkPrivileges("ROLE_SERVICE_UPDATE") && <ServicesModal />}
      />
      <Route
        path="/service/assign/part/:id"
        element={
          checkPrivileges("ROLE_SERVICE_ITEM_ASSIGN") ||
          checkPrivileges("ROLE_SERVICE_ITEM_UNASSIGN") ? (
            <ServiceItemsTable />
          ) : null
        }
      />
      <Route
        path="/service/assign/vehicle-type/:id"
        element={
          checkPrivileges("ROLE_SERVICE_VEHICLETYPE_ASSIGN") ||
          checkPrivileges("ROLE_SERVICE_VEHICLETYPE_UNASSIGN") ? (
            <ServiceVehicleTypesTable />
          ) : null
        }
      />
      <Route
        path="/service/assign/station/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_SERVICE_STATION_ASSIGN") ||
          checkPrivileges("ROLE_SERVICE_STATION_UNASSIGN") ? (
            <ServiceStationsTable />
          ) : null
        }
      />
      <Route
        path="/service/assign/model/:id"
        element={
          checkPrivileges("ROLE_SERVICE_MODEL_ASSIGN") ||
          checkPrivileges("ROLE_SERVICE_MODEL_UNASSIGN") ? (
            <ServiceModelsTable />
          ) : null
        }
      />
      <Route
        path="/service/assign/price-list/:id"
        element={
          checkPrivileges("ROLE_SERVICE_PRICELIST_ASSIGN") ||
          checkPrivileges("ROLE_SERVICE_PRICELIST_UNASSIGN") ? (
            <ServicesPricelistListing />
          ) : null
        }
      />
      <Route
        path="/business-groups"
        element={
          checkPrivileges("ROLE_BUSINESSGROUP_VIEW") && (
            <BusinessGroupsListing />
          )
        }
      />
      <Route
        path="/business-group/create"
        element={
          checkPrivileges("ROLE_BUSINESSGROUP_CREATE") && (
            <BusinessGroupsModal />
          )
        }
      />
      <Route
        path="/business-group/:id"
        element={
          checkPrivileges("ROLE_BUSINESSGROUP_UPDATE") && (
            <BusinessGroupsModal />
          )
        }
      />
      <Route
        path="/business-group/assign/station/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_BUSINESSGROUP_STATION_ASSIGN") ||
          checkPrivileges("ROLE_BUSINESSGROUP_STATION_UNASSIGN") ? (
            <BusinessGroupStationTable />
          ) : null
        }
      />
      <Route
        path="/units"
        element={checkPrivileges("ROLE_UNIT_VIEW") && <UnitsListing />}
      />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route
        path="/unit/create"
        element={checkPrivileges("ROLE_UNIT_CREATE") && <UnitModal />}
      />
      <Route
        path="/unit/:id"
        element={checkPrivileges("ROLE_UNIT_UPDATE") && <UnitModal />}
      />
      <Route
        path="/warehouses"
        element={checkPrivileges("ROLE_WAREHOUSE_VIEW") && <WarehouseListing />}
      />
      <Route
        path="/warehouse/create"
        element={checkPrivileges("ROLE_WAREHOUSE_CREATE") && <WarehouseModal />}
      />
      <Route
        path="/warehouse/:id"
        element={checkPrivileges("ROLE_WAREHOUSE_UPDATE") && <WarehouseModal />}
      />
      <Route
        path="/suppliers"
        element={checkPrivileges("ROLE_VENDOR_VIEW") && <SupplierListing />}
      />
      <Route
        path="/supplier/create"
        element={checkPrivileges("ROLE_VENDOR_CREATE") && <SupplierModal />}
      />
      <Route
        path="/supplier/:id"
        element={checkPrivileges("ROLE_VENDOR_UPDATE") && <SupplierModal />}
      />
      <Route
        path="/station-groups"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATIONGROUP_VIEW") && <StationGroupsListing />
        }
      />
      <Route
        path="/station-group/create"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATIONGROUP_CREATE") && <StationGroupsModal />
        }
      />
      <Route
        path="/station-group/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATIONGROUP_UPDATE") && <StationGroupsModal />
        }
      />
      <Route
        path="/station-group/assign/station/:id"
        element={
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATIONGROUP_STATION_ASSIGN") ||
          checkPrivileges("ROLE_STATIONGROUP_STATION_UNASSIGN") ? (
            <StationGroupStationTable />
          ) : null
        }
      />
      <Route
        path="/packages-group"
        element={
          checkPrivileges("ROLE_PACKAGEGROUP_VIEW") && <PackageGroupListing />
        }
      />
      <Route
        path="/package-group/create"
        element={
          checkPrivileges("ROLE_PACKAGEGROUP_CREATE") && <PackageGroupModal />
        }
      />
      <Route
        path="/package-group/:id"
        element={
          checkPrivileges("ROLE_PACKAGEGROUP_UPDATE") && <PackageGroupModal />
        }
      />
      <Route
        path="/package-group/assign/package/:id"
        element={
          checkPrivileges("ROLE_PACKAGEGROUP_PACKAGE_ASSIGN") ||
          checkPrivileges("ROLE_PACKAGEGROUP_PACKAGE_UNASSIGN") ? (
            <PackageGroupPackageTable />
          ) : null
        }
      />
      <Route
        path="/manufacturers"
        element={
          checkPrivileges("ROLE_MANUFACTURER_VIEW") && <ManufacturersListing />
        }
      />
      <Route
        path="/manufacturer/create"
        element={
          checkPrivileges("ROLE_MANUFACTURER_CREATE") && <ManufacturersModal />
        }
      />
      <Route
        path="/manufacturer/:id"
        element={
          checkPrivileges("ROLE_MANUFACTURER_UPDATE") && <ManufacturersModal />
        }
      />
      <Route
        path="/tax-procedures"
        element={
          checkPrivileges("ROLE_TAXPROCEDURE_VIEW") && <TaxProcedureListing />
        }
      />
      <Route
        path="/tax-procedure/create"
        element={
          checkPrivileges("ROLE_TAXPROCEDURE_CREATE") && <TaxProcedureModal />
        }
      />
      <Route
        path="/tax-procedure/:id"
        element={
          checkPrivileges("ROLE_TAXPROCEDURE_UPDATE") && <TaxProcedureModal />
        }
      />
      <Route
        path="/account-settings"
        element={
          checkPrivileges("ROLE_BUSINESS_UPDATE") && <BusinessSettings />
        }
      />
      <Route
        path="/account-settings/change-password"
        element={<ChangePassword />}
      />
      <Route
        path="/account-settings/notification-settings"
        element={
          checkSubscriptions("NOTIFICATIONS") && <NotificationSettings />
        }
      />
      <Route
        path="/account-settings/subscription-plan-usage"
        element={<SubscriptionPlanUsage />}
      />
      <Route
        path="/business-templates"
        element={
          checkSubscriptions("CUSTOM_TEMPLATES") &&
          checkPrivileges("ROLE_INVOICE_TEMPLATE_VIEW") && (
            <InvoiceTemplatesListing />
          )
        }
      />
      <Route
        path="/job-cards"
        element={
          checkSubscriptions("JOB_CARDS") &&
          checkPrivileges("ROLE_JOBCARD_VIEW") && <JobCardListing />
        }
      />
      <Route
        path="/job-card/:id"
        element={
          checkSubscriptions("JOB_CARDS") &&
          checkPrivileges("ROLE_JOBCARD_UPDATE") && <JobCardModal />
        }
      />
      <Route
        path="/work-orders"
        element={
          checkSubscriptions("WORK_ORDERS") &&
          checkPrivileges("ROLE_WORKORDER_VIEW") && <WorkOrderListing />
        }
      />
      <Route
        path="/work-order/:id"
        element={
          checkSubscriptions("WORK_ORDERS") &&
          checkPrivileges("ROLE_WORKORDER_UPDATE") && <WorkOrderModal />
        }
      />
      <Route
        path="/invoices"
        element={
          checkSubscriptions("INVOICES") &&
          checkPrivileges("ROLE_INVOICE_VIEW") && <InvoiceListing />
        }
      />
      <Route
        path="/invoices/:id"
        element={
          checkSubscriptions("INVOICES") &&
          checkPrivileges("ROLE_INVOICE_UPDATE") && <InvoiceModal />
        }
      />
      <Route
        path="/payments"
        element={
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PAYMENT_VIEW") && <PaymentListing />
        }
      />
      <Route
        path="/payment/create"
        element={
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PAYMENT_CREATE") && <PaymentModal />
        }
      />
      <Route
        path="/payment/:id"
        element={checkSubscriptions("PAYMENT") && <ViewPayment />}
      />
      <Route
        path="/status/:typename"
        element={
          checkPrivileges("ROLE_BUSINESSSTATUS_VIEW") && <StatusesListing />
        }
      />
      <Route
        path="/status/:typename/create"
        element={
          checkPrivileges("ROLE_BUSINESSSTATUS_CREATE") && <StatusesModal />
        }
      />
      <Route
        path="/status/:typename/edit/:id"
        element={
          checkPrivileges("ROLE_BUSINESSSTATUS_UPDATE") && <StatusesModal />
        }
      />
      <Route
        path="/vehicle-statuses"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_BUSINESSSTATUS_VIEW") && (
            <VehicleStatusListing />
          )
        }
      />
      <Route
        path="/vehicle-status/create"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_BUSINESSSTATUS_CREATE") && (
            <VehicleStatusModal />
          )
        }
      />
      <Route
        path="/vehicle-status/:id"
        element={
          checkPrivileges("ROLE_BUSINESSSTATUS_UPDATE") && (
            <VehicleStatusModal />
          )
        }
      />
      <Route
        path="/payment-modes"
        element={
          checkPrivileges("ROLE_PAYMENT_MODE_VIEW") && <PaymentModeListing />
        }
      />
      <Route
        path="/payment-modes/create"
        element={
          checkPrivileges("ROLE_PAYMENT_MODE_CREATE") && <PaymentModeModal />
        }
      />
      <Route
        path="/payment-modes/:id"
        element={
          checkPrivileges("ROLE_PAYMENT_MODE_UPDATE") && <PaymentModeModal />
        }
      />
      <Route
        path="/checklists"
        element={
          checkSubscriptions("CHECKLIST") &&
          checkPrivileges("ROLE_CHECKLIST_VIEW") && <ChecklistListing />
        }
      />
      <Route
        path="/checklist/create"
        element={
          checkSubscriptions("CHECKLIST") &&
          checkPrivileges("ROLE_CHECKLIST_CREATE") && <ChecklistModal />
        }
      />
      <Route
        path="/checklist/:id"
        element={
          checkSubscriptions("CHECKLIST") &&
          checkPrivileges("ROLE_CHECKLIST_UPDATE") && <ChecklistModal />
        }
      />
      <Route
        path="/inventory"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) ? (
            <Navigate to="/inventory/purchase-orders" />
          ) : checkSubscriptionFeatureItem(
              "INVENTORY_PURCHASING",
              "DIRECT SR",
              ["RFQ"],
            ) ? (
            <Navigate to="/inventory/stock-receives" />
          ) : (
            checkSubscriptions("INVENTORY_PURCHASING") && (
              <Navigate to="/inventory/supplier-bills" />
            )
          )
        }
      />
      <Route
        path="/inventory/purchase-orders"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) &&
          checkPrivileges("ROLE_PURCHASEORDER_VIEW") && <PurchaseOrderListing />
        }
      />
      <Route
        path="/inventory/new-purchase"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) &&
          checkPrivileges("ROLE_PURCHASEORDER_CREATE") && <NewPurchase />
        }
      />
      <Route
        path="/inventory/purchase/:id"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) && <InventorySteps />
        }
      />
      <Route
        path="/inventory/supplier-bills"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_PURCHASEINVOICE_VIEW") && (
            <PurchaseInvoiceListing />
          )
        }
      />
      <Route
        path="/inventory/new-supplier-bill/"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_PURCHASEINVOICE_CREATE") && (
            <PurchaseInvoiceCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/supplier-bill/:id"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_PURCHASEINVOICE_AUTHORIZE") && (
            <PurchaseInvoiceCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/stock-receives"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "DIRECT SR", [
            "RFQ",
          ]) &&
          checkPrivileges("ROLE_STOCKRECEIPT_VIEW") && <StockReceivedListing />
        }
      />
      <Route
        path="/inventory/new-stock-receives/"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "DIRECT SR", [
            "RFQ",
          ]) &&
          checkPrivileges("ROLE_STOCKRECEIPT_CREATE") && (
            <StockReceivedCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/stock-receives/:id"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "DIRECT SR", [
            "RFQ",
          ]) &&
          checkPrivileges("ROLE_STOCKRECEIPT_AUTHORIZE") && (
            <StockReceivedCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/debit-note"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_PURCHASE_CREDITDEBITNOTE_VIEW") && (
            <CreditNoteListing />
          )
        }
      />
      <Route
        path="/inventory/new-debit-note"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_PURCHASE_CREDITDEBITNOTE_CREATE") && (
            <CreditNoteCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/debit-note/:id"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_PURCHASE_CREDITDEBITNOTE_AUTHORIZE") && (
            <CreditNoteCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/unstock"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_UNSTOCK_VIEW") && <UnstockListing />
        }
      />
      <Route
        path="/inventory/new-unstock/"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_UNSTOCK_CREATE") && <UnstockCreateUpdate />
        }
      />
      <Route
        path="/inventory/unstock/:id"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") &&
          checkPrivileges("ROLE_UNSTOCK_AUTHORIZE") && <UnstockCreateUpdate />
        }
      />
      <Route
        path="/expense-types"
        element={
          checkSubscriptions("EXPENSE_MANAGEMENT") &&
          checkPrivileges("ROLE_EXPENSE_TYPE_VIEW") && <ExpenseTypeListing />
        }
      />
      <Route
        path="/expense-type/create"
        element={
          checkSubscriptions("EXPENSE_MANAGEMENT") &&
          checkPrivileges("ROLE_EXPENSE_TYPE_CREATE") && <ExpenseTypeModal />
        }
      />
      <Route
        path="/expense-type/:id"
        element={
          checkSubscriptions("EXPENSE_MANAGEMENT") &&
          checkPrivileges("ROLE_EXPENSE_TYPE_UPDATE") && <ExpenseTypeModal />
        }
      />
      <Route
        path="/checklistitems/:clid"
        element={
          checkSubscriptions("CHECKLIST") &&
          checkPrivileges("ROLE_CHECKLISTITEM_VIEW") && <CheckListItemListing />
        }
      />
      <Route
        path="/checklistitem/:clid/create"
        element={
          checkSubscriptions("CHECKLIST") &&
          checkPrivileges("ROLE_CHECKLISTITEM_CREATE") && <ChecklistItemModal />
        }
      />
      <Route
        path="/checklistitem/:clid/edit/:id"
        element={
          checkSubscriptions("CHECKLIST") &&
          checkPrivileges("ROLE_CHECKLISTITEM_UPDATE") && <ChecklistItemModal />
        }
      />
      <Route
        path="/inventory/stock-transfers"
        element={
          checkPrivileges("ROLE_STOCKTRANSFER_VIEW") && <StockTransferListing />
        }
      />
      <Route
        path="/inventory/stock-transfer"
        element={
          checkPrivileges("ROLE_STOCKTRANSFER_CREATE") && (
            <StockTransferCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/stock-transfer/:id"
        element={
          checkPrivileges("ROLE_STOCKTRANSFER_VIEW") && (
            <StockTransferCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/stock-adjustments"
        element={
          checkPrivileges("ROLE_INVENTORYADJUSTMENT_VIEW") && (
            <StockAdjustmentListing />
          )
        }
      />
      <Route
        path="/inventory/stock-adjustment"
        element={
          checkPrivileges("ROLE_INVENTORYADJUSTMENT_CREATE") && (
            <StockAdjustmentCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/stock-adjustment/:id"
        element={
          checkPrivileges("ROLE_INVENTORYADJUSTMENT_VIEW") && (
            <StockAdjustmentCreateUpdate />
          )
        }
      />
      <Route
        path="/activity-logs"
        element={
          checkSubscriptions("AUDIT_LOGS") &&
          checkPrivileges("ROLE_REQUESTLOG_VIEW") && <ActivityLogsListing />
        }
      />
      <Route path="/reports" element={<Reports />} />
      <Route
        path="/states"
        element={checkPrivileges("ROLE_STATE_VIEW") && <StateListing />}
      />
      <Route
        path="/state/create"
        element={checkPrivileges("ROLE_STATE_CREATE") && <StateModal />}
      />
      <Route
        path="/state/:id"
        element={checkPrivileges("ROLE_STATE_UPDATE") && <StateModal />}
      />
      <Route
        path="/inventory/stock-receives/:id/print"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "DIRECT SR", [
            "RFQ",
          ]) && <PrintStockReceived />
        }
      />
      <Route
        path="/inventory/supplier-bill/:id/print"
        element={
          checkSubscriptions("INVENTORY_PURCHASING") && <PrintPurchaseInvoice />
        }
      />
      <Route
        path="/inventory/debit-note/:id/print"
        element={<PrintCreditNote />}
      />
      <Route
        path="/inventory/unstock/:id/print"
        element={checkSubscriptions("INVENTORY_PURCHASING") && <PrintUnstock />}
      />
      <Route
        path="/inventory/stock-transfer/:id/print"
        element={<PrintStockTransfer />}
      />
      <Route
        path="/inventory/stock-adjustment/:id/print"
        element={<PrintStockAdjustment />}
      />
      <Route
        path="/inventory/purchase/:id/print"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) && <PrintPurchaseOrder />
        }
      />
      <Route
        path="/inventory/purchase/:id/print/supplier-bill"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) && <PrintPurchaseOrderInvoice />
        }
      />
      <Route
        path="/inventory/purchase/:id/print/stock"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) && <PrintPurchaseOrderStockReceived />
        }
      />
      <Route
        path="/inventory/purchase/:id/print/debit-note"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) && <PrintPurchaseOrderCreditNote />
        }
      />
      <Route
        path="/inventory/purchase/:id/print/unstock"
        element={
          checkSubscriptionFeatureItem("INVENTORY_PURCHASING", "PO FLOW", [
            "RFQ",
            "DIRECT SR",
          ]) && <PrintPurchaseOrderUnstock />
        }
      />
      <Route
        path="/expenses"
        element={
          checkSubscriptions("EXPENSE_MANAGEMENT") &&
          checkPrivileges("ROLE_EXPENSE_MANAGER_VIEW") && <ExpensesListing />
        }
      />
      <Route
        path="/expense/add"
        element={
          checkSubscriptions("EXPENSE_MANAGEMENT") &&
          checkPrivileges("ROLE_EXPENSE_MANAGER_CREATE") && <ExpensesModal />
        }
      />
      <Route
        path="/expense/:id"
        element={
          checkSubscriptions("EXPENSE_MANAGEMENT") &&
          checkPrivileges("ROLE_EXPENSE_MANAGER_UPDATE") && <ExpensesModal />
        }
      />
      <Route
        path="/expense/view/:id"
        element={checkSubscriptions("EXPENSE_MANAGEMENT") && <ViewExpense />}
      />
      <Route
        path="/client/:id/account/:accountId/drivers/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENT_UPDATE") && <DriversListing />
        }
      />
      <Route
        path="/client/:id/account/:accountId/driver/create/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENT_UPDATE") && <DriversModal />
        }
      />
      <Route
        path="/client/:id/account/:accountId/driver/:driverId/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_CLIENT_UPDATE") && <DriversModal />
        }
      />
      <Route
        path="/client/:id/account/:accountId/vehicles/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_VEHICLE_VIEW") && <ClientVehicles />
        }
      />
      <Route
        path="/client/:id/account/:accountId/invoices/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_INVOICE_VIEW") && <ClientInvoices />
        }
      />
      <Route
        path="/client/:id/account/:accountId/delivery-notes/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkPrivileges("ROLE_DELIVERY_NOTE_VIEW") && <ClientDeliveryNotes />
        }
      />
      <Route
        path="/client/:id/account/:accountId/payments/invoicingPreference/:invoicingPreference"
        element={
          checkSubscriptions("CLIENT") &&
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PAYMENT_VIEW") && <ClientPayments />
        }
      />
      <Route
        path="/client/:id/account/:accountId/reviews/invoicingPreference/:invoicingPreference"
        element={checkSubscriptions("CLIENT") && <ClientReviews />}
      />
      <Route
        path="/client/:id/account/:accountId/integrations/invoicingPreference/:invoicingPreference"
        element={checkSubscriptions("CLIENT") && <ClientIntegrationsListing />}
      />
      <Route
        path="/client/:id/account/:accountId/integration/add/invoicingPreference/:invoicingPreference"
        element={checkSubscriptions("CLIENT") && <ClientIntegrationModal />}
      />
      <Route
        path="/client/:id/account/:accountId/integration/:integrationId/invoicingPreference/:invoicingPreference"
        element={checkSubscriptions("CLIENT") && <ClientIntegrationModal />}
      />
      <Route
        path="/inventory/supplier-payments"
        element={
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PURCHASE_PAYMENT_VIEW") && (
            <PurchasePaymentListing />
          )
        }
      />
      <Route
        path="/inventory/new-supplier-payment/"
        element={
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PURCHASE_PAYMENT_CREATE") && (
            <PurchasePaymentCreateUpdate />
          )
        }
      />
      <Route
        path="/inventory/supplier-payment/:id/print"
        element={checkSubscriptions("PAYMENT") && <PrintPurchasePayment />}
      />
      <Route
        path="/inventory/supplier-payment/:id"
        element={
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PURCHASE_PAYMENT_UPDATE") && (
            <PurchasePaymentCreateUpdate />
          )
        }
      />
      <Route
        path="/sales-credit-notes"
        element={
          checkPrivileges("ROLE_CREDITNOTE_VIEW") && <SalesCreditNotesListing />
        }
      />
      <Route
        path="/sales-credit-note/create"
        element={
          checkPrivileges("ROLE_CREDITNOTE_CREATE") && <SalesCreditNotesModal />
        }
      />
      <Route
        path="/analytics"
        element={checkPrivileges("ROLE_ANALYTICS_DASHBOARD") && <Analytics />}
      />
      <Route
        path="/cancellation-reasons"
        element={
          checkPrivileges("ROLE_CANCELLATION_REASON_VIEW") && (
            <CancellationReasonListing />
          )
        }
      />
      <Route
        path="/cancellation-reason/create"
        element={
          checkPrivileges("ROLE_CANCELLATION_REASON_CREATE") && (
            <CancellationReasonModal />
          )
        }
      />
      <Route
        path="/cancellation-reason/:id"
        element={
          checkPrivileges("ROLE_CANCELLATION_REASON_UPDATE") && (
            <CancellationReasonModal />
          )
        }
      />
      <Route
        path="/estimates"
        element={
          checkSubscriptions("ESTIMATES") &&
          checkPrivileges("ROLE_ESTIMATION_VIEW") && <EstimationListing />
        }
      />
      <Route
        path="/estimate/:id"
        element={
          checkSubscriptions("ESTIMATES") &&
          checkPrivileges("ROLE_ESTIMATION_UPDATE") && <EstimationModal />
        }
      />
      <Route
        path="/customer/:id/vehicles"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkPrivileges("ROLE_VEHICLE_VIEW") && <CustomerVehicles />
        }
      />
      <Route
        path="/customer/:id/invoices"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkPrivileges("ROLE_INVOICE_VIEW") && <CustomerInvoices />
        }
      />
      <Route
        path="/customer/:id/payments"
        element={
          checkSubscriptions("CUSTOMER") &&
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PAYMENT_VIEW") && <CustomerPayments />
        }
      />
      <Route
        path="/inventory/stock-level"
        element={checkPrivileges("ROLE_ITEM_VIEW") && <StockLevelListing />}
      />
      <Route
        path="/analytics/kpis"
        element={checkPrivileges("ROLE_KPI_ANALYTICS_VIEW") && <KpiDashboard />}
      />
      <Route
        path="/insurance-companies"
        element={
          checkPrivileges("ROLE_INSURANCECOMPANY_VIEW") && (
            <InsuranceCompaniesListing />
          )
        }
      />
      <Route
        path="/insurance-company/create"
        element={
          checkPrivileges("ROLE_INSURANCECOMPANY_CREATE") && (
            <InsuranceCompaniesModal />
          )
        }
      />
      <Route
        path="/insurance-company/:id"
        element={
          checkPrivileges("ROLE_INSURANCECOMPANY_UPDATE") && (
            <InsuranceCompaniesModal />
          )
        }
      />
      <Route
        path="/business-template/create"
        element={
          checkSubscriptions("CUSTOM_TEMPLATES") &&
          checkPrivileges("ROLE_INVOICE_TEMPLATE_CREATE") && (
            <InvoiceTemplatesModal />
          )
        }
      />
      <Route
        path="/business-template/:id"
        element={
          checkSubscriptions("CUSTOM_TEMPLATES") &&
          checkPrivileges("ROLE_INVOICE_TEMPLATE_UPDATE") && (
            <InvoiceTemplatesModal />
          )
        }
      />
      <Route
        path="/accounts-summary"
        element={checkPrivileges("ROLE_ACCOUNT_SUMMARY") && <AccountsSummary />}
      />
      <Route
        path="/insurance-company/:id/insurance-policies"
        element={
          checkPrivileges("ROLE_INSURANCEPOLICY_VIEW") && (
            <InsurancePoliciesListing />
          )
        }
      />
      <Route
        path="/insurance-company/:id/insurance-policy/create"
        element={
          checkPrivileges("ROLE_INSURANCEPOLICY_CREATE") && (
            <InsurancePoliciesModal />
          )
        }
      />
      <Route
        path="/insurance-company/:id/insurance-policy/:policyId"
        element={
          checkPrivileges("ROLE_INSURANCEPOLICY_UPDATE") && (
            <InsurancePoliciesModal />
          )
        }
      />
      <Route
        path="/delivery-notes"
        element={
          checkSubscriptions("DELIVERY_NOTE") &&
          checkPrivileges("ROLE_DELIVERY_NOTE_VIEW") && <DeliveryNotesListing />
        }
      />
      <Route
        path="/delivery-notes/:id"
        element={
          checkSubscriptions("DELIVERY_NOTE") &&
          checkPrivileges("ROLE_DELIVERY_NOTE_VIEW") && <DeliveryNoteModal />
        }
      />
      <Route
        path="/delivery-notes/:id/template/:templateId"
        element={
          checkSubscriptions("DELIVERY_NOTE") && <DeliveryNoteDownloadPreview />
        }
      />
      <Route
        path="/business/:id/integrations"
        element={
          loggedInUserData?.type === -1 || loggedInUserData?.type === 100 ? (
            <IntegrationsListing />
          ) : null
        }
      />
      <Route
        path="/business/:id/integration/add"
        element={
          loggedInUserData?.type === -1 || loggedInUserData?.type === 100 ? (
            <IntegrationModal />
          ) : null
        }
      />
      <Route
        path="/business/:id/integration/:integrationId"
        element={
          loggedInUserData?.type === -1 || loggedInUserData?.type === 100 ? (
            <IntegrationModal />
          ) : null
        }
      />
      <Route
        path="/invoices/:id/template/:templateId"
        element={checkSubscriptions("INVOICES") && <InvoiceDownloadPreview />}
      />
      <Route
        path="/account/:name/:id/ledger"
        element={
          checkSubscriptions("ACCOUNT_MODULE") && <AccountLedgerListing />
        }
      />
      <Route
        path="/supplier/:id/purchase-orders"
        element={
          checkPrivileges("ROLE_PURCHASEORDER_VIEW") && (
            <SupplierPurchaseOrders />
          )
        }
      />
      <Route
        path="/supplier/:id/bills"
        element={
          checkPrivileges("ROLE_PURCHASEINVOICE_VIEW") && <SupplierBills />
        }
      />
      <Route
        path="/supplier/:id/stock-receives"
        element={
          checkPrivileges("ROLE_STOCKRECEIPT_VIEW") && <SupplierStockReceives />
        }
      />
      <Route
        path="/supplier/:id/debit-notes"
        element={
          checkPrivileges("ROLE_PURCHASE_CREDITDEBITNOTE_VIEW") && (
            <SupplierDebitNotes />
          )
        }
      />
      <Route
        path="/supplier/:id/payments"
        element={
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PURCHASE_PAYMENT_VIEW") && <SupplierPayments />
        }
      />
      <Route
        path="/inter-account-transfers"
        element={
          checkSubscriptions("ACCOUNT_MODULE") && (
            <InterAccountTransferListing />
          )
        }
      />
      <Route
        path="/inter-account-transfer/create"
        element={
          checkSubscriptions("ACCOUNT_MODULE") && <InterAccountTransferCreate />
        }
      />
      <Route
        path="/hosting-details"
        element={loggedInUserData?.type === -1 && <HostingDetailsListing />}
      />
      <Route
        path="/hosting-details/create"
        element={loggedInUserData?.type === -1 && <HostingDetailsModal />}
      />
      <Route
        path="/hosting-details/:id"
        element={loggedInUserData?.type === -1 && <HostingDetailsModal />}
      />
      <Route
        path="/vehicle/:id/invoices"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_INVOICE_VIEW") && <VehicleInvoices />
        }
      />
      <Route
        path="/vehicle/:id/bookings"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_BOOKING_VIEW") && <VehicleBookings />
        }
      />
      <Route
        path="/vehicle/:id/job-cards"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_JOBCARD_VIEW") && <VehicleJobCards />
        }
      />
      <Route
        path="/vehicle/:id/work-orders"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_WORKORDER_VIEW") && <VehicleWorkOrders />
        }
      />
      <Route
        path="/vehicle/:id/inspections"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLEINSPECTION_VIEW") && (
            <VehicleInspections />
          )
        }
      />
      <Route
        path="/vehicle/:id/payments"
        element={
          checkSubscriptions("VEHICLES") &&
          checkSubscriptions("PAYMENT") &&
          checkPrivileges("ROLE_PAYMENT_VIEW") && <VehiclePayments />
        }
      />
      <Route
        path="/vehicle/:id/service-recommendations"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_RECOMMENDEDSERVICE_VIEW") && (
            <VehicleServiceRecommendations />
          )
        }
      />
      <Route
        path="/vehicle/:id/service-history"
        element={
          checkSubscriptions("VEHICLES") &&
          checkPrivileges("ROLE_VEHICLE_SERVICE_HISTORY_VIEW") && (
            <VehicleServiceHistory />
          )
        }
      />
      <Route path="/customer/:id/reviews" element={<CustomerReviews />} />
      <Route
        path="/inspections"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_VEHICLEINSPECTION_VIEW") && (
            <InspectionListing />
          )
        }
      />
      <Route
        path="/inspection/:id"
        element={
          checkSubscriptions("INSPECTIONS") &&
          checkPrivileges("ROLE_VEHICLEINSPECTION_VIEW") && <ViewInspection />
        }
      />
      <Route
        path="/inspection/:id/template/:templateId"
        element={
          checkSubscriptions("INSPECTIONS") && <InspectionDownloadPreview />
        }
      />
      <Route
        path="/sales-credit-note/:id/view"
        element={
          checkPrivileges("ROLE_CREDITNOTE_VIEW") && <ViewSalesCreditNote />
        }
      />
      <Route
        path="/business/:id/stations/create"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_CREATE") && <StationModal />
        }
      />
      <Route
        path="/business/:id/stations/:stationId/assign/account"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
          // checkSubscriptions("STATIONS") &&
          (checkPrivileges("ROLE_STATION_BANKACCOUNT_ASSIGN") ||
            checkPrivileges("ROLE_STATION_BANKACCOUNT_UNASSIGN")) ? (
            <StationBankAccountTable />
          ) : null
        }
      />
      <Route
        path="/business/:id/stations/:stationId/assign/user"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
          checkSubscriptions("USERS") &&
          (checkPrivileges("ROLE_STATION_USER_ASSIGN") ||
            checkPrivileges("ROLE_STATION_USER_ASSIGN")) ? (
            <StationUserTable />
          ) : null
        }
      />
      <Route
        path="/business/:id/stations/:stationId/terms-and-conditions"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_TERMANDCONDITION_VIEW") && (
            <StationTermsAndConditions />
          )
        }
      />
      <Route
        path="/business/:id/stations/:stationId/plan-usage"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_UPDATE") && <StationPlanUsage />
        }
      />
      <Route
        path="/business/:id/stations/:stationId"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
          // checkSubscriptions("STATIONS") &&
          checkPrivileges("ROLE_STATION_UPDATE") && <StationModal />
        }
      />
      <Route
        path="/business/:id/stations"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) && (
            <BusinessStations />
          )
        }
      />
      <Route
        path="/business/:id/subscription-analytics"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) && (
            <SubscriptionAnalytics />
          )
        }
      />
      <Route
        path="/analytics/inventory"
        element={
          checkPrivileges("ROLE_INVENTORY_DASHBOARD") && <InventoryAnalytics />
        }
      />
      <Route
        path="/analytics/customer"
        element={
          checkPrivileges("ROLE_ANALYTICS_DASHBOARD") && (
            <CustomerAnalyticsDashboard />
          )
        }
      />
      <Route
        path="/integration-logs"
        element={
          checkPrivileges("ROLE_INTEGRATION_LOG_VIEW") && (
            <IntegrationLogsListing />
          )
        }
      />
      <Route
        path="/subscription-plans"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) && (
            <SubscriptionPlansListing />
          )
        }
      />
      <Route
        path="/subscription-plans/create"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) && (
            <SubscriptionPlansModal />
          )
        }
      />
      <Route
        path="/subscription-plans/:id"
        element={
          (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) && (
            <SubscriptionPlansModal />
          )
        }
      />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;
